export default "__VITE_ASSET__3d8e11d9__"